//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: ['canEditCertificate'],
    data: function data() {
        return {
            url: route('sanctum_api.projects.index'),
            columns: [{
                name: 'last_export',
                label: trans('columns.export'),
                sortable: true,
                html: true,
                data: function data(item) {
                    return item.last_export == null ? '<i class="fa fa-star"></i>' : '';
                }
            }, {
                name: 'name',
                label: trans('columns.name'),
                sortable: true
            }, {
                name: 'company',
                label: trans('columns.company_name'),
                sortable: false,
                data: function data(item) {
                    return item.company ? item.company.name : '–';
                }
            }]
        };
    },

    methods: {
        deleteProject: function deleteProject(project) {
            var url = '/manage/project/delete/' + project;

            window.swal({
                title: window.i18n.messages.confirm_header,
                text: window.i18n.messages.confirm_delete,
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: window.i18n.messages.proceed,
                cancelButtonText: window.i18n.messages.cancel
            }).then(function (result) {
                if (result.value) {
                    axios.delete(url).then(function (response) {
                        window.swal({
                            title: window.i18n.messages.success,
                            html: window.i18n.messages.delete_success,
                            type: 'success',
                            timer: 1000,
                            showConfirmButton: false
                        }).then(function () {
                            window.location.reload();
                        });
                    }).catch(function (error) {
                        window.swal({
                            title: window.i18n.messages.error,
                            html: window.i18n.messages.delete_error,
                            type: 'error'
                        });
                    });
                }
            });
        },
        publishProject: function publishProject(project) {
            var url = '/de/manage/project/publish/' + project;

            window.swal({
                title: 'Sind Sie sich sicher ?',
                text: 'Soll die Schulung wirklich veröffentlicht werden ?',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Fortfahren',
                cancelButtonText: window.i18n.messages.cancel
            }).then(function (result) {
                if (result.value) {
                    axios.get(url).then(function (response) {
                        window.swal({
                            title: window.i18n.messages.success,
                            html: 'Die Schulung wurde veröffentlicht!',
                            type: 'info'
                        });
                    }).catch(function (error) {
                        window.swal({
                            title: window.i18n.messages.error,
                            html: 'Fehler beim Veröffentlichen der Schulung',
                            type: 'error'
                        });
                    });
                }
            });
        },
        copyProject: function copyProject(project) {
            var url = route('project.copy', project);

            window.swal({
                title: 'Name der neuen Schulung',
                input: 'text',
                inputAttributes: {
                    autocapitalize: 'off'
                },
                showCancelButton: true,
                confirmButtonText: 'Kopieren',
                showLoaderOnConfirm: true,
                preConfirm: function preConfirm(project) {
                    return axios.post(url, {
                        name: project
                    }).then(function (response) {
                        if (!response.data.success) {
                            throw new Error(response.data.data);
                        }
                    }).catch(function (error) {
                        window.swal.showValidationMessage(error);
                    });
                },
                allowOutsideClick: function allowOutsideClick() {
                    return !window.swal.isLoading();
                }
            }).then(function (result) {
                if (result.value) {
                    window.swal({
                        position: 'top-end',
                        type: 'success',
                        title: 'Schulung kopiert',
                        showConfirmButton: false,
                        timer: 1500
                    });
                }
            });
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]]}!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/js/components/Projects.vue
// module id = 47
// module chunks = 0